export enum QuoteClientAnswer {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  REJECTED_WITH_RETURN = 'RejectedWithReturn',
  REJECTED_WITH_DESTRUCTION = 'RejectedWithDestruction',
  CANCELLED = 'Cancelled',
}
